import dayjs from "dayjs";
import { useCallback } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

const R = Resources.Dashboard.RelativeDate;

export const useRelativeDays = () => {
	const { t } = useResource();

	return useCallback(
		(dateStr?: string | null): string => {
			if (!dateStr) {
				return "";
			}
			const diff = dayjs(dateStr)
				.startOf("day")
				.diff(dayjs().startOf("day"), "day");

			if (diff === 0) {
				return t(R.today);
			}

			const count = Math.abs(diff);

			return diff > 0 ? t(R.future, { count }) : t(R.past, { count });
		},
		[t],
	);
};
